/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchWithQuantity } from './BranchWithQuantity';
import {
    BranchWithQuantityFromJSON,
    BranchWithQuantityFromJSONTyped,
    BranchWithQuantityToJSON,
    BranchWithQuantityToJSONTyped,
} from './BranchWithQuantity';

/**
 * 
 * @export
 * @interface MenuMixBusinessBranchesWithQuantityResponse
 */
export interface MenuMixBusinessBranchesWithQuantityResponse {
    /**
     * 
     * @type {Array<BranchWithQuantity>}
     * @memberof MenuMixBusinessBranchesWithQuantityResponse
     */
    data: Array<BranchWithQuantity>;
}

/**
 * Check if a given object implements the MenuMixBusinessBranchesWithQuantityResponse interface.
 */
export function instanceOfMenuMixBusinessBranchesWithQuantityResponse(value: object): value is MenuMixBusinessBranchesWithQuantityResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MenuMixBusinessBranchesWithQuantityResponseFromJSON(json: any): MenuMixBusinessBranchesWithQuantityResponse {
    return MenuMixBusinessBranchesWithQuantityResponseFromJSONTyped(json, false);
}

export function MenuMixBusinessBranchesWithQuantityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuMixBusinessBranchesWithQuantityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchWithQuantityFromJSON)),
    };
}

export function MenuMixBusinessBranchesWithQuantityResponseToJSON(json: any): MenuMixBusinessBranchesWithQuantityResponse {
    return MenuMixBusinessBranchesWithQuantityResponseToJSONTyped(json, false);
}

export function MenuMixBusinessBranchesWithQuantityResponseToJSONTyped(value?: MenuMixBusinessBranchesWithQuantityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchWithQuantityToJSON)),
    };
}

